// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-bar {\n  width: 54%;\n  margin-top: 2px;\n}\n.progress-bar .eymp-progressbar .progress-label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
